var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VFlex',{staticClass:"display-only"},[(_vm.hint.length)?_c('span',{staticClass:"hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }